import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaLocaleProvider, WeaTools} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import MarqueeCom from '../common/MarqueeCom';
import NewsType from './NewsType';
//内容组件
class EContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
        this.toggleTabPage = this.toggleTabPage.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
                refresh: false,
            }); 
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    toggleTabPage(tabid){
        const { currentTab } = this.state;
        this.setState({
            refresh: !(tabid === currentTab),
        });
        this.handleTabData(tabid);
    }

    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        this.setState({
            currentTab: tabid,
            tabdata: ls.getJSONObj('tabdata-' + params.eid + '-' + tabid),
        });
        WeaTools.callApi('/api/portal/element/loginnewstab', 'POST', {...params, tabid}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
       });
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state; 
        const { tabids, titles, esetting } = edata;
        const { eid } = config.params;
        let { fontStyle } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        esetting.fontStyle = fontStyle;
        const { contentview = {} } = config.item;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        let more = '';
        if (tabdata) {
            more = tabdata.more;
        }
        let tabdata_img = {};
        if(!isEmpty(tabdata)){
            tabdata_img = _.cloneDeep(tabdata);
            tabdata_img.tabsetting.imgs=[];
        }
        let contentHtml = !isEmpty(tabdata) ? <NewsType eid={eid} data={!refresh ? tabdata: tabdata_img} esetting={esetting}/> : <div/>;
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            more,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            handleTabData: this.toggleTabPage
        }
        return <div>
            <Title {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height}}>
                <Spin spinning={refresh}>{contentHtml}</Spin>
            </div>
         </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
EContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EContent);
export default EContent;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/loginnews/EContent.js